import axios from "../api/axios";
import store from "../store";

export default {
  async execute(method, resource, data) {
    return axios
      .locationEndpoint({
        method,
        url: resource,
        data,
        headers: {
          customerId:
            store.getters.companyIdDropdown == null
              ? ""
              : store.getters.companyIdDropdown,
        },
      })
      .then((req) => {
        return req.data;
      });
  },
  getAddressByLatitudeAndLongitude(companyId, latitude, longitude) {
    return this.execute(
      "get",
      `location/address/${companyId}?latitude=${latitude}&longitude=${longitude}`
    );
  },
};
